import { render } from "./KeeperDashboard.vue?vue&type=template&id=8c4bde64&scoped=true"
import script from "./KeeperDashboard.vue?vue&type=script&lang=js"
export * from "./KeeperDashboard.vue?vue&type=script&lang=js"

import "./KeeperDashboard.vue?vue&type=style&index=0&id=8c4bde64&scoped=true&lang=css"
import "./KeeperDashboard.vue?vue&type=style&index=1&id=8c4bde64&scoped=true&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c4bde64"]])

export default __exports__